import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TicketStatus } from "../../models/ticket.model";


@Component({
    selector: 'charla-ticket-status',
    template: `
        <span class="status" [ngClass]="{ 
                                'open': status == TicketStatus.Open, 
                                'in-progress': status == TicketStatus.InProgress || status == TicketStatus.PendingCustomer, 
                                'closed': status == TicketStatus.Closed || status == TicketStatus.Resolved }">
            {{ lookup[status - 1] }} <span *ngIf="post">{{post}}</span>
        </span>
    `,
    styleUrls: ['status.component.scss'],
    imports: [CommonModule]
  })
  export class CharlaTicketStatusComponent {

    @Input() status: number = 0;
    @Input() post: string = "";
    TicketStatus = TicketStatus;
    lookup: string[] = ["Open", "In Progress", "Closed", "Pending Customer", "Resolved"]; 

    constructor(
    ){

    }


  }